import { render, staticRenderFns } from "./_dashboardop.vue?vue&type=template&id=ba9ee43e&lang=pug"
import script from "./_dashboardop.vue?vue&type=script&lang=js"
export * from "./_dashboardop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports